import React, { useEffect, useState } from 'react';
import { doc, getDoc } from "firebase/firestore";
import CardBooking from '../Components/card';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import Footer from '../Components/footer';

export default function Bookings(props) {

    const [Data, setData] = useState([]);
    const [User, setUser] = useState('');

    useEffect(() => {
        onAuthStateChanged(props.auth, async (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                // setUser(user);
                // getData();
                const docRef = doc(props.db, "users", user.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    console.log("Document data:", docSnap.data());
                    const data = docSnap.data();
                    // console.log(data.bookings[0]["boat"]);
                    setUser(user);
                    setData(data.bookings);
                } else {
                    // docSnap.data() will be undefined in this case
                    console.log("No such document!");
                }
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [props.auth, props.db])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link ">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link active">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section>
                <div class="coverBigNews"></div>
            </section>
            
            <div>
            <section style={{ padding: '20px 0px 7px 0px' }} className="d-flex flex-column align-items-center">
            <h2 className="yesBookings">My bookings</h2>
            </section>
            </div>
            {Data.length > 0 ? Data.map((element, index) => {
                return (
                    <CardBooking route={element.route}
                        boat={element.boat}
                        date={element.date}
                        user={User.uid}
                    />
                ); 
            }):null} 
            <Footer />
        </div>
    );
}

